<template>
  <label>
    <slot></slot>
  </label>
</template>

<script>
import "@/assets/css/index.css"
export default {
  name: 'j-base-label'
}
</script>



// WEBPACK FOOTER //
// src/components/JBaseLabel/index.vue